export default [
  {
    path: '/hall/index/:id',
    component: () => import('@/views/Hall/Index'),
    name: 'HallIndex',
    meta: {
      title: '纪念馆首页',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/hall/home/:id',
    component: () => import('@/views/Hall/Home'),
    name: 'HallHome',
    meta: {
      title: '纪念馆主页',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/hall/intro/:id',
    component: () => import('@/views/Hall/introduction'),
    name: 'HallIntroduction',
    meta: {
      title: '纪念馆简介',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/hall/leaveMsg/:id',
    component: () => import('@/views/Hall/LeaveMsg'),
    name: 'HallLeaveMsg',
    meta: {
      title: '纪念馆留言',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/hall/addMsg',
    component: () => import('@/views/Hall/AddMsg'),
    name: 'AddHallMsg',
    meta: {
      title: '纪念馆留言',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/hall/photo/:id',
    component: () => import('@/views/Hall/Photo'),
    name: 'HallPhoto',
    meta: {
      title: '纪念馆相册',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/hall/article/:id',
    component: () => import('@/views/Hall/Article'),
    name: 'HallArticle',
    meta: {
      title: '纪念馆文章',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/hall/ArticleShow',
    component: () => import('@/views/Hall/ArticleShow'),
    name: 'ArticleShow',
    meta: {
      title: '纪念馆文章详情',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/hall/record/:id',
    component: () => import('@/views/Hall/Record'),
    name: 'SacrificeRecord',
    meta: {
      title: '纪念馆祭祀记录',
      noCache: true,
      affix: true
    }
  }
]
